import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../../../../components/ui/Button';
import { WpsConfirmWarning } from '../../../../models/payroll';
import { WarningList } from '../../WpsCenter/components/InlineConfirm';

interface WpsMarkPaidWarningProps {
  warnings: WpsConfirmWarning[];
  busy: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

/**
 * Above the table, under the action that raised it. Names the people and says the salary paid email goes out. Under the
 * Refuse setting there is nothing to confirm, so the way forward offered is the WPS Center or a smaller selection.
 */
export const WpsMarkPaidWarning: React.FC<WpsMarkPaidWarningProps> = ({ warnings, busy, onConfirm, onDismiss }) => {
  const { t } = useTranslation();
  const refused = warnings.some(w => w.code === 'markPaidHeldRefused');

  return (
    <div
      className="space-y-3 rounded-lg border border-amber-500/30 bg-amber-500/5 p-4"
      role="alert"
      data-testid="wps-mark-paid-warning"
    >
      <p className="text-sm font-semibold text-foreground">
        {refused ? t('payroll.wps.uae.markPaid.titleRefused') : t('payroll.wps.uae.markPaid.title')}
      </p>
      <WarningList warnings={warnings} />
      <div className="flex flex-wrap items-center gap-2">
        {!refused && (
          <Button size="sm" onClick={onConfirm} loading={busy} disabled={busy} data-testid="wps-mark-paid-confirm">
            {t('payroll.wps.uae.markPaid.confirm')}
          </Button>
        )}
        <Button size="sm" variant="outline" onClick={onDismiss} disabled={busy} data-testid="wps-mark-paid-cancel">
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button asChild size="sm" variant="ghost">
          <Link to="/payroll/wps-center" data-testid="wps-mark-paid-center">{t('payroll.wps.uae.markPaid.openCenter')}</Link>
        </Button>
      </div>
    </div>
  );
};
